export const getStyledSelectPopoverTop = (
  showSearch: boolean,
  isTop: boolean
) => {
  if (showSearch) {
    return isTop ? '4px' : '-1px';
  }
  return '0px';
};
